// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__PfS4s","margin-left":"styles_margin-left__IuF2i"};